export const formatRating = (x: number) => {
    if (isNaN(x)) return '--';
    const withOneDecimalPoint = x.toFixed(1);
    if (withOneDecimalPoint.endsWith('0')) return x.toFixed(0);
    return withOneDecimalPoint;
};
